import Grid from '@mui/material/Grid';
import BaseTable from 'components/Tables/BaseTable';
import React from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData } from 'selectors/generic';
import columns from 'utils/tables/columns/administration/scenarios';

const Component = props => {
  const { scenariosData, rmsById, flowsById, productsById, descriptorsById } = props;
  const tableRef = React.useRef(null);

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        columns={columns(rmsById, flowsById, productsById, descriptorsById)}
        data={scenariosData}
        onRowClick={() => null}
      />
    </Grid>
  );
};

const makeMapStateToProps = () => {
  // Cloned, like every other table in the app. material-table writes its own
  // bookkeeping onto the rows it is given, and the rows in the store are now
  // the ones `models` holds - there is no second copy left to absorb that.
  //
  // Built once rather than inside mapStateToProps: createSelector holds one
  // result, so a selector made on each call has an empty cache every time and
  // deep-clones the whole slice per render. The factory itself is only this
  // file matching the other fifty - it gives each instance its own memo, which
  // earns its keep for a selector that reads ownProps and nothing here does.
  const immutableScenarios = getImmutableStoreData('scenarios');
  const mapStateToProps = (state, props) => ({
    scenariosData: immutableScenarios(state),
    rmsById: state.rawMaterials.models,
    flowsById: state.flows.models,
    productsById: state.products.models,
    descriptorsById: state.descriptors.models
  });
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(Component);
